module.exports = "/images/marking-icon-note.svg?1f0a90e0d7c771db2368a4f3b664d03d";